import { Drawer, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import type { KnowledgeScope } from '../constants/knowledgeScope'
import {
  KnowledgeFilePreviewPanel,
  downloadKnowledgeAttachment,
  useKnowledgePreviewActiveFile,
} from './KnowledgeFilePreviewPanel'
import './KnowledgeFilePreviewDrawer.css'

type ScopeParams = { scope: KnowledgeScope }

type PreviewDrawerProps = {
  open: boolean
  itemId: number | null
  scopeParams: ScopeParams
  onClose: () => void
}

export function KnowledgeFilePreviewDrawer({
  open,
  itemId,
  scopeParams,
  onClose,
}: PreviewDrawerProps) {
  const { item, activeFile } = useKnowledgePreviewActiveFile(itemId, scopeParams, open)
  const previewTitle =
    activeFile?.original_name || activeFile?.stored_name || item?.title || '文件预览'

  return (
    <Drawer
      title={item ? previewTitle : '文件预览'}
      open={open}
      onClose={onClose}
      width={960}
      styles={{ body: { paddingTop: 12 } }}
      destroyOnHidden
      className="kb-file-preview-drawer"
      extra={
        activeFile && itemId ? (
          <Button
            icon={<DownloadOutlined />}
            onClick={() => void downloadKnowledgeAttachment(itemId, activeFile, scopeParams)}
          >
            下载
          </Button>
        ) : null
      }
    >
      <KnowledgeFilePreviewPanel
        itemId={itemId}
        scopeParams={scopeParams}
        active={open}
      />
    </Drawer>
  )
}
